import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkeletonTile = () => {
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-raised",
    inlineSize: "100%",
    blockSize: "40px",
    borderRadius: "200"
  });
};
const TilesSectionSkeleton = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "tiles-section-skeleton",
    flexDirection: "column",
    paddingBlock: "200",
    gap: "200",
    children: [/*#__PURE__*/_jsx(SkeletonTile, {}), /*#__PURE__*/_jsx(SkeletonTile, {}), /*#__PURE__*/_jsx(SkeletonTile, {})]
  });
};
export default TilesSectionSkeleton;